<div class="backdrop" role="status" aria-live="polite" aria-busy="true">
  <div class="loader-content" [class.progress-loader]="showProgress">
    
    <!-- Progress Mode -->
    @if(showProgress) {
      <div class="progress-container">
        <!-- Spinner -->
        <!-- <mat-progress-spinner mode="indeterminate" diameter="48" class="spinner">
        </mat-progress-spinner> -->
        <!-- <img src="images/gif/coffee-break.gif" alt="Loading" class="spinner" width="200px"> -->
        <img src="images/gif/loader.gif" alt="Loading" class="spinner" width="200px">
        
        <!-- Main Title -->
        <h2 class="main-title">{{ title }}</h2>
        @if (servedFromCache) {
          <div class="cache-badge-tiny">served from cache</div>
        }
        
        <!-- Progress Bar -->
        <div class="progress-bar-container">
          <mat-progress-bar 
            mode="determinate" 
            [value]="progressPercentage"
            class="progress-bar">
          </mat-progress-bar>
          <!-- @if (isOverviewStagesMode) {
            <div class="progress-text overview-stages-progress">
              <span class="overview-pct">{{ progressPercentage | number:'1.0-0' }}%</span>
              <span class="overview-unit">({{ getDisplayedCompletedTabs() }}/{{ totalTabs }} overview)</span>
            </div>
            <div class="overview-stage-line">
              Step {{ overviewStageInfo.step }} of {{ overviewStageInfo.total }}:
              <strong>{{ overviewStageInfo.label }}</strong>
            </div>
            @if (showOverviewTypicalTimeHint) {
              <div class="overview-typical-time">Typical time: {{ overviewTypicalTimeHint }}</div>
            }
          } @else { -->
            <div class="progress-text">
              {{ progressPercentage | number:'1.0-0' }}% Complete
            </div>
          <!-- } -->
        </div>
        
        @if(currentTab && !isOverviewStagesMode) {
          <div class="current-tab">
            <p>🔄 Currently processing: <strong>{{ currentTab }}</strong></p>
          </div>
        }
        
        <!-- Completed Tabs -->
        @if(completedTabNames.length > 0) {
          <div class="completed-tabs">
            <h4>✅ Completed:</h4>
            <div class="completed-list">
              @for(tab of completedTabNames; track tab) {
                <span class="completed-tab-item">{{ tab }}</span>
              }
            </div>
          </div>
        }
        
        <!-- Encouraging Message -->
        <div class="encouragement-message">
          <p>{{ getEncouragementMessage() }}</p>
        </div>
        
        <!-- Action Buttons -->
        <div class="action-buttons">
          @if (showSkipAuditsButton && currentTaskId && !auditsSkipped) {
            <button 
              mat-raised-button 
              color="accent"
              (click)="onSkipAuditsClick()"
              class="skip-audits-button">
              Skip Audits
            </button>
          }
          @if (auditsSkipped) {
            <div class="audits-skipped-message">
              <span class="audit-message-text">* Audits are not included in the default analysis. Use the Re-Audit button in each audit tab to run them individually.</span>
            </div>
          }
          @if (showBackgroundButton && showBackgroundLoadButton) {
            <button 
              mat-raised-button 
              color="primary"
              (click)="onBackgroundLoadClick()"
              class="background-load-button">
              Run in background
            </button>
          }
          @if (showCancelButton) {
            <button 
              mat-raised-button 
              color="warn"
              (click)="onCancelClick()"
              class="cancel-button">
              Re-Run Analysis
            </button>
          }
        </div>
      </div>
    }
    
    <!-- Standard Mode -->
    @else {
      @if(isCustomLoader){
        <img src="images/gif/coffee-break.gif" alt="Loading" class="spinner" width="200px">
      } @else {
        <mat-progress-spinner mode="indeterminate" diameter="56" class="spinner">
        </mat-progress-spinner>
      }
      <p class="please-wait">{{ title }}</p>
      
      <!-- Background Load Button (shown after delay) -->
      @if (showBackgroundLoadButton && showBackgroundButton) {
        <div class="background-load-container">
          <button 
            mat-raised-button 
            color="primary"
            (click)="onBackgroundLoadClick()"
            class="background-load-button">
            Run in background
          </button>
        </div>
      }
    }
    
  </div>
  <!-- Clicks should not pass through the overlay -->
</div>